export const EQUIPMENT_PURCHASES = 'Equipment Purchases';
export const FIT_OUTS_RENOVATIONS = 'Fit Outs and Renovations';
export const INVENTORY_STOCK = 'Inventory and Stock';
export const MARKETING = 'Marketing';
export const HIRING_EMPLOYEES = 'Hiring Employees';
export const DEBT_CONSOLIDATION = 'Debt Consolidation';
export const EXPANSION = 'Expansion';
export const PAY_SUPPLIERS = 'Pay Suppliers';
export const OTHER = 'Other';
